import { Skeleton } from "primereact/skeleton"

type Props = {
  className?: string
} & React.ComponentProps<"div">

export function MemberOffersWrapperSkeleton({ className, ...props }: Props) {
  const defaultClassName = "flex flex-column w-full gap-3"
  return (
    <div className={className ?? defaultClassName} {...props}>
      <div className="flex w-full gap-2">
        <Skeleton height="2.3rem" width="11rem" className="flex rounded-full " />
        <Skeleton height="2.3rem" width="7rem" className="flex rounded-full " />
        <Skeleton height="2.3rem" width="9rem" className="flex rounded-full " />
      </div>
      <div className="flex flex-column w-full gap-3">
        <Skeleton height="4.5rem" borderRadius="20px" />
        <Skeleton height="4.5rem" borderRadius="20px" />
        <Skeleton height="4.5rem" borderRadius="20px" />
        <Skeleton height="4.5rem" borderRadius="20px" />
      </div>
    </div>
  )
}
